"use client";

import { useSearchParams } from "next/navigation";

import { T } from "@/lib/i18n/T";
import { CatalogView } from "@/components/catalog/CatalogView";

export function SearchResults({ locale }: { locale: string }) {
  const query = (useSearchParams().get("q") ?? "").trim();

  if (!query) {
    return (
      <div className="rb-catalog-screen" data-nav-theme="light">
        <div className="rb-catalog-container">
          <div className="rb-catalog-results">
            <div className="rb-catalog-empty">
              <h4><T id="search.noQuery.title" /></h4>
              <p><T id="search.noQuery.body" /></p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <CatalogView
      locale={locale}
      mode={{ kind: "search", query }}
      heading={
        <div className="rb-catalog-title">
          <h1><T id="search.resultsFor" values={{ query }} /></h1>
        </div>
      }
    />
  );
}
